import { render, staticRenderFns } from "./Industries.vue?vue&type=template&id=036a1992&scoped=true&"
import script from "./Industries.vue?vue&type=script&lang=js&"
export * from "./Industries.vue?vue&type=script&lang=js&"
import style0 from "./Industries.vue?vue&type=style&index=0&id=036a1992&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036a1992",
  null
  
)

export default component.exports